import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { onSystemNotificationClosed, clearMessage } from 'actions/Notifications'
import { toast } from 'react-toastify'

const levelToClassProps = {
  error: { classColor: 'danger', textColor: 'white' },
  warning: { classColor: 'warning', textColor: 'white' },
  info: { classColor: 'info', textColor: 'black' },
  default: { classColor: 'light', textColor: 'black' }
}

let SystemNotification = ({ dispatch, notification }) => {
  const levelClassProps = levelToClassProps[notification.level] ? levelToClassProps[notification.level] : levelToClassProps['default']
  const classColor = levelClassProps.classColor
  const textColor = levelClassProps.textColor
  const className = `bg-${classColor} text-${textColor} border-${classColor} alert alert-success alert-dismissible fade show`
  return (
    <div className={className} role="alert">
      <button onClick={() => dispatch(onSystemNotificationClosed(notification.id))} type="button" className="close" aria-label="Close"><span aria-hidden="true">×</span></button>
      <p>
        <strong>{notification.header}</strong>
      </p>
      {notification.message ? (<p>{notification.message}</p>) : null}
      {notification.details ? (
        <div>
          {notification.details.map((detail, index) => ( <p key={index}>{detail}</p>))}
        </div>
      ) : null}
    </div>
  )
}

SystemNotification.propTypes = {
  notification: PropTypes.object.isRequired
}

SystemNotification = connect()(SystemNotification)


export let SystemNotificationList = ({ notifications }) => {
  return notifications ? notifications.map((notification) => (<SystemNotification key={notification.id} notification={notification} />)) : null
}

const mapStateToProps = state => {
    return {
      notifications: state.system.notifications
    }
}

SystemNotificationList = connect(mapStateToProps)(SystemNotificationList)

// Listens for messages sent via showMessage action and toasts them
export let MessageToaster = ({message, clearMessage}) => {
  if (message && message.text) {
    let toastMethod = toast.info
    if (message.level) {
      switch (message.level) {
        case 'warn':
        case 'warning':
          toastMethod = toast.warn
          break
        case 'error':
          toastMethod = toast.error
          break
        default:
          toastMethod = toast.info
          break
      }
    }

    let options = message.important ? { autoClose: false } : undefined
    toastMethod(message.text, options)

    clearMessage()
  }
  return null // never render myself
}

MessageToaster = connect(
  ({system: { message }}) => ({ message }),
  { clearMessage }
)(MessageToaster)



// WEBPACK FOOTER //
// ./Linkgua/components/Notifications/index.js